import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createWrapper } from 'next-redux-wrapper';
import { reducer } from './reducer';

const store = () => createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));

export const wrapper = createWrapper(store, { debug: false });
